import React from 'react';
import {
  ImgDescCardContainer,
  JetImg,
  DescBox,
  Title,
  DescBoxContent,
  Desc,
  Header,
  RightSlot,
} from 'components/ImgDescCard/ImgDescCard.style.jsx';

const ImgDescCard = ({
  isLeft,
  imgSrc,
  imgAlt,
  title,
  desc,
  children,
  gap,
  rightSlot,
  flipImg,
}) => {
  return (
    <ImgDescCardContainer $isLeft={isLeft} $gap={gap} $hasRightSlot={!!rightSlot}>
      <JetImg
        src={imgSrc}
        alt={imgAlt}
        $hasRightSlot={!!rightSlot}
        $isLeft={isLeft}
        $flip={!!flipImg}
      ></JetImg>
      <DescBox $hasRightSlot={!!rightSlot} $isLeft={isLeft}>
        <Header>
          <Title>{title}</Title>
          {desc && desc.map((text, index) => <Desc key={index}>{text}</Desc>)}
        </Header>

        <DescBoxContent>{children}</DescBoxContent>
      </DescBox>
      {rightSlot && <RightSlot>{rightSlot}</RightSlot>}
    </ImgDescCardContainer>
  );
};

export default ImgDescCard;
